module.exports = {
  planned: "planned",
  running: "running",
  paused: "paused",
  expired: "expired",
  cancelled: "cancelled",
};
